// Global video player state
let currentPlayingVideo = null;

// Initialize video cards functionality
function initVideoCards() {
  // Find all video wrappers in the document
  const videoWrappers = document.querySelectorAll('.card-video-wrapper');
  
  videoWrappers.forEach(wrapper => {
    // Skip if already initialized
    if (wrapper.dataset.videoInitialized === 'true') return;
    wrapper.dataset.videoInitialized = 'true';
    
    const playButton = wrapper.querySelector('.card-video-play-button');
    const videoElement = wrapper.querySelector('.card-video-element');
    const video = wrapper.querySelector('.card-video');
    const productCard = wrapper.querySelector('.card_media_product');
    
    // Ensure product card is visible by default when video exists
    if (productCard && video) {
      productCard.style.visibility = 'visible';
      productCard.style.opacity = '1';
      productCard.style.transform = 'translateY(0)';
    }
    
    if (!video || !playButton) return;
    
    // Play button click handler
    playButton.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      playVideo(wrapper, videoElement, video);
    });
    
    // Video area click to pause
    wrapper.addEventListener('click', function(e) {
      if (e.target === playButton || playButton.contains(e.target)) return;
      if (wrapper.classList.contains('playing')) {
        pauseVideo(wrapper, video);
      }
    });
  });
}

function playVideo(wrapper, videoElement, video) {
  // Pause currently playing video if any
  if (currentPlayingVideo && currentPlayingVideo !== wrapper) {
    const currentVideo = currentPlayingVideo.querySelector('.card-video');
    if (currentVideo) {
      currentVideo.pause();
      currentPlayingVideo.classList.remove('playing');
    }
  }
  
  if (video) {
    const isMuted = videoElement.dataset.videoMuted === 'true';
    video.muted = isMuted === 'true' || isMuted === true;
    
    video.play().then(() => {
      wrapper.classList.add('playing');
      currentPlayingVideo = wrapper;
    }).catch(err => {
      console.error('Error playing video:', err);
    });
  }
}

function pauseVideo(wrapper, video) {
  if (video) {
    video.pause();
    wrapper.classList.remove('playing');
    if (currentPlayingVideo === wrapper) {
      currentPlayingVideo = null;
    }
  }
}

// Initialize on DOM ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initVideoCards);
} else {
  initVideoCards();
}

// Re-initialize when new content is added (for dynamic content)
const observer = new MutationObserver(function(mutations) {
  initVideoCards();
});

observer.observe(document.body, {
  childList: true,
  subtree: true
});

if (!customElements.get('image-cards')) {
    customElements.define(
      'image-cards',
      class ImageCards extends HTMLElement {
        constructor() {
          super();
        }
  
        connectedCallback() {
          this.selectors = {
            sliderWrapper: '.image-cards__inner',
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
            pagination: '.swiper-pagination',
          };
          this.classes = {
            grid: 'f-grid',
            swiper: 'swiper',
            swiperWrapper: 'swiper-wrapper',
          };
  
          this.sectionId = this.dataset.sectionId;
          this.sectionEl = this.closest(`.section-${this.sectionId}`);
          this.sliderWrapper = this.querySelector(this.selectors.sliderWrapper);
  
          this.enableSlider = this.dataset.enableSlider === 'true';
          this.items = parseInt(this.dataset.items);
          this.tabletItems = parseInt(this.dataset.tabletItems);
          this.laptopItems = parseInt(this.dataset.laptopItems);
          this.paginationType = this.dataset.paginationType || 'bullets';
  
          this.sliderInstance = false;
  
          // Initialize video cards when this element is connected
          setTimeout(() => {
            initVideoCards();
          }, 100);
  
          if (!this.enableSlider) return;
  
          const mql = window.matchMedia(FoxTheme.config.mediaQueryMobile);
          mql.onchange = this.init.bind(this);
          this.init();
        }
  
        init() {
          if (FoxTheme.config.mqlMobile) {
            this.destroySlider();
          } else {
            this.initSlider();
          }
        }
  
        initSlider() {
          if (typeof this.sliderInstance === 'object') return;
          const columnGap = window.getComputedStyle(this.sliderWrapper).getPropertyValue('--f-column-gap');
          const spaceBetween = parseFloat(columnGap.replace('rem', '')) * 10;
  
          this.sliderOptions = {
            slidesPerView: 2,
            spaceBetween: spaceBetween,
            navigation: {
              nextEl: this.sectionEl.querySelector(this.selectors.nextEl),
              prevEl: this.sectionEl.querySelector(this.selectors.prevEl),
            },
            pagination: {
              el: this.sectionEl.querySelector(this.selectors.pagination),
              type: this.paginationType,
            },
            breakpoints: {
              768: {
                slidesPerView: this.tabletItems,
              },
              1024: {
                slidesPerView: this.laptopItems,
              },
              1280: {
                slidesPerView: this.items,
              },
            },
            loop: false,
            threshold: 2,
            watchSlidesProgress: true,
            mousewheel: {
              enabled: true,
              forceToAxis: true,
            },
          };
  
          this.classList.add(this.classes.swiper);
          this.sliderWrapper.classList.remove(this.classes.grid);
          this.sliderWrapper.classList.add(this.classes.swiperWrapper);
  
          this.sliderInstance = new window.FoxTheme.Carousel(this, this.sliderOptions, [FoxTheme.Swiper.Mousewheel]);
          this.sliderInstance.init();
  
          if (Shopify.designMode && typeof this.sliderInstance === 'object') {
            document.addEventListener('shopify:block:select', (e) => {
              if (e.detail.sectionId != this.sectionId) return;
              let { target } = e;
              const index = Number(target.dataset.index);
  
              this.sliderInstance.slider.slideTo(index);
            });
          }
        }
  
        destroySlider() {
          this.classList.remove(this.classes.swiper);
          this.sliderWrapper.classList.remove(this.classes.swiperWrapper);
          this.sliderWrapper.classList.add(this.classes.grid);
          if (typeof this.sliderInstance !== 'object') return;
          this.sliderInstance.slider.destroy();
          this.sliderInstance = false;
        }
      }
    );
  }
  